import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASEURL } from "../../constants";
import CreateCourseModal from "./CreateCourseModal";

import PublishedCourses from "./PublishedCourses.jsx";
import DraftCourses from "./DraftCourses.jsx";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import InReviewCourses from "./InReviewCourses.jsx";
import RejectedCourses from "./RejectedCourses.jsx";

const MyCourses = () => {
  const [publishedCourses, setPublishedCourses] = useState([]);
  const [draftCourses, setDraftCourses] = useState([]);
  const [inReviewCourses, setInReviewCourses] = useState([]);
  const [rejectedCourses, setRejectedCourses] = useState([]);
  const [viewToggle, setViewToggle] = useState(
    () => localStorage.getItem("viewMode") || "card"
  );
  const { searchTerm } = useOutletContext();
  const { activeTab } = useParams();
  const navigate = useNavigate();

   // Update localStorage whenever viewToggle changes
   useEffect(() => {
    localStorage.setItem("viewMode", viewToggle);
  }, [viewToggle]);

  useEffect(() => {
    const fetchAllCourses = async () => {
      const userId = localStorage.getItem("auth");

      if (userId) {
        const response = await axios.post(`${BASEURL}/api/fetch-courses`, {
          user_id: userId,
        });

        const publishedCoursesResponse = await axios.post(
          `${BASEURL}/api/fetch-published-courses`
        );
        const publishedCourseData = publishedCoursesResponse.data.courseData;

        const publishedCourses = publishedCourseData.filter(
          (course) =>
            course.verify_status === "verified" &&
            course.course_status === "completed" &&
            course.publish_status === "published"
        );
        const courseData = response.data.courseData;
        const draftCourses = courseData.filter(
          (course) =>
            course.verify_status === "not verified" &&
            course.course_status === "incompleted" &&
            course.publish_status === "unpublished"
        );
        const inReviewCourses = courseData.filter(
          (course) =>
            course.verify_status === "pending" &&
            course.course_status === "completed" &&
            course.publish_status === "published"
        );
        const rejectedCourses = courseData.filter(
          (course) =>
            course.verify_status === "rejected" &&
            course.course_status === "completed" &&
            course.publish_status === "published"
        );

        // const publishedCourses = courseData.filter(course =>(course.verify_status === 'verified' && course.course_status === 'completed' && course.publish_status === 'published') )
        console.log("in review courses", inReviewCourses);
        setDraftCourses(draftCourses);
        setInReviewCourses(inReviewCourses);
        setPublishedCourses(publishedCourses);
        setRejectedCourses(rejectedCourses);
        console.log("draft courses using new logic", publishedCourses);
      }
    };

    fetchAllCourses();
  }, []);

  function onPublishSccuess(id) {
    //id of the published course
    const course = draftCourses.find((course) => course.id === id);

    setDraftCourses((draftCourses) => {
      return draftCourses.filter((course) => course.id !== id);
    });

    setInReviewCourses([...inReviewCourses, course]);
  }

  return (
    <>
      <div className="p-6">
        <div className="flex justify-between mb-6">
          <div className="flex items-center overflow-x-auto whitespace-nowrap">
            <p className="text-2xl text-slate-900 font-bold cursor-pointer">
              My Courses
            </p>
          </div>
        </div>
        <div className="flex items-center justify-between">
          <div class="flex overflow-x-auto mb-6 overflow-y-hidden border-b border-gray-200 whitespace-nowrap">
            <button
              className={`inline-flex gap-2 px-4 py-2 items-center h-10 -mb-px text-sm  text-center ${
                activeTab === "publishedCourses"
                ? "text-customPrimaryPurple bg-transparent border-b-[3px] font-bold border-customPrimaryPurple"
                : "text-gray-700 font-normal bg-transparent border-b-2 border-transparent"
                } sm:text-base whitespace-nowrap cursor-pointer focus:outline-none`}
              onClick={() => navigate("/myCourses/publishedCourses")}
            >
              <div>Published Courses</div>
              <div className="text-xs px-2 py-1 bg-borderColor rounded-md">
                {publishedCourses.length}
              </div>
            </button>
            <button
              className={`flex gap-2 px-4 py-2 items-center h-10  -mb-px text-sm  text-center ${activeTab === "draftCourses"
                ? "text-customPrimaryPurple bg-transparent border-b-[3px] font-bold border-customPrimaryPurple"
                : "text-gray-700 bg-transparent border-b-2 font-normal border-transparent"
                } sm:text-base whitespace-nowrap cursor-pointer focus:outline-none`}
              onClick={() => navigate("/myCourses/draftCourses")}
            >
              <div className="font-inter">Drafts Courses</div>
              <div className="text-xs px-2 py-1 bg-borderColor rounded-md">
                {draftCourses.length}
              </div>
            </button>
            <button
              className={`flex gap-2 px-4 py-2 items-center h-10  -mb-px text-sm text-center ${activeTab === "reviewCourses"
                ? "text-customPrimaryPurple bg-transparent border-b-[3px] font-bold border-customPrimaryPurple"
                : "text-gray-700 bg-transparent font-normal border-b-2 border-transparent"
                } sm:text-base whitespace-nowrap cursor-pointer focus:outline-none`}
              onClick={() => navigate("/myCourses/reviewCourses")}
            >
              <div>In review</div>
              <div className="text-xs px-2 py-1 bg-borderColor rounded-md">
                {inReviewCourses.length}
              </div>
            </button>
            <button
              className={`inline-flex gap-2 px-4 py-2 items-center h-10 -mb-px text-sm text-center ${activeTab === "rejectedCourses"
                ? "text-customPrimaryPurple bg-transparent border-b-[3px] font-bold border-customPrimaryPurple"
                : "text-gray-700 font-normal bg-transparent border-b-2 border-transparent"
                } sm:text-base whitespace-nowrap cursor-pointer focus:outline-none`}
              onClick={() => navigate("/myCourses/rejectedCourses")}
            >
              <div>Rejected</div>
              <div className="text-xs px-2 py-1 bg-borderColor rounded-md">
                {rejectedCourses.length}
              </div>
            </button>
          </div>

          <div className="mb-6 bg-borderColor rounded-md p-1 flex cursor-pointer">
            <div  className={viewToggle=="card"?"bg-gray-500 rounded":""} onClick={()=>setViewToggle("card")}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke={viewToggle=="card"?"white":"currentColor"} className="size-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z" />
              </svg>

            </div>
            <div className={viewToggle=="tile"?`bg-gray-500  rounded`:""} onClick={()=>setViewToggle("tile")}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke={viewToggle=="tile"?"white":"currentColor"} className="size-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
              </svg>

            </div>
          </div>
        </div>
        <div className="mx-auto">
          {activeTab === "publishedCourses" && (
            <PublishedCourses
              searchTerm={searchTerm}
              courseArray={publishedCourses}
              viewToggle={viewToggle}
            />
          )}
          {activeTab === "draftCourses" && (
            <DraftCourses
              searchTerm={searchTerm}
              courseArray={draftCourses}
              setDraftCourses={setDraftCourses}
              onPublishSccuess={onPublishSccuess}
              viewToggle={viewToggle}
            />
          )}
          {activeTab === "reviewCourses" && (
            <InReviewCourses
              searchTerm={searchTerm}
              courseArray={inReviewCourses}
              viewToggle={viewToggle}
            />
          )}
          {activeTab === "rejectedCourses" && (
            <RejectedCourses
              searchTerm={searchTerm}
              courseArray={rejectedCourses}
              viewToggle={viewToggle}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default MyCourses;
